import { BillingFieldsBaseEnum } from '@sola/schema/dotcom/checkout/billingInfo.js';
import { UniqueAddressMap } from '@sola/schema/dotcom/shared/address.js';
import { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.js';
import { useSupporterBillingAddresses } from '@sola/supporter-sdk/hooks/payment-methods.js';
import { createAddressHash } from '@sola/supporter-sdk/utils/addresses.js';

import { Skeleton } from '../../atoms/skeleton/skeleton';
import { AddressSelect, AddressSelectProps } from './address-select.js';

type AddressSelectSupporterProps = Omit<
  AddressSelectProps,
  'name' | 'addresses' | 'defaultAddress'
> & {
  name?: string;
  paymentMethod?: GraphQLSupporterPaymentMethod;
};

export const getCurrentPaymentMethodHash = (
  addresses?: UniqueAddressMap,
  paymentMethod?: GraphQLSupporterPaymentMethod,
) => {
  if (!addresses?.size || !paymentMethod?.billingAddress) {
    return;
  }

  const { street, city, postalCode } = paymentMethod.billingAddress;

  if (!street || !city || !postalCode) {
    return;
  }

  // Find matching address by hash
  return createAddressHash(street, city, postalCode);
};

export const AddressSelectSupporter: React.FC<AddressSelectSupporterProps> = ({
  name,
  paymentMethod,
  ...props
}) => {
  const { supporterAddresses, isLoading, isFetching, isPending, isError } =
    useSupporterBillingAddresses();
  const defaultAddress = getCurrentPaymentMethodHash(
    supporterAddresses,
    paymentMethod,
  );

  if ((isLoading || isFetching || isPending) && !isError) {
    return <Skeleton height={50} />;
  }

  return (
    <AddressSelect
      {...props}
      name={name || BillingFieldsBaseEnum.AddressOption}
      defaultAddress={defaultAddress}
      addresses={supporterAddresses}
    />
  );
};
